import { supabase } from "@/lib/supabase/supabaseClient";
import { GetSurveyBankProps } from ".";
import { groupQuestionsByDependencies } from "@/features/question/hooks/useQuery/useGetQuestionsBySurveyId/utils/groupQuestionsByDependencies";

export const getSurveyBank = async ({ crmSystem, organisationId, search }: GetSurveyBankProps) => {
    let query = supabase
        .from('survey_bank')
        .select(`
            *,
            author:user(*),
            survey_bank_question_bank(*)
        `)
        .order("created_at", { ascending: false })
        .eq('organisation_id', organisationId);

    // Only apply crm_system filter if it's not 'all'
    if (crmSystem) {
        query = query.in('crm_system', Array.isArray(crmSystem) ? crmSystem : [crmSystem]);
    }

    if (search) {
        query = query.textSearch('question', search, {
            type: 'websearch'
        });
    }

    const data = await query.throwOnError().then(res => res.data);

    // Transform data here instead of in select
    if (!data) return null;

    const resWithGroupedQuestions = data.map((res) => {
        return {
            ...res,
            questions: {
                grouped: groupQuestionsByDependencies(
                    res.survey_bank_question_bank,
                ),
                questions: res.survey_bank_question_bank,
            }
        }
    });

    const groupedByCrmSystem = resWithGroupedQuestions.reduce((acc, survey) => {
        const key = survey.crm_system || 'unknown';
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(survey);
        return acc;
    }, {} as Record<string, typeof resWithGroupedQuestions>);

    return groupedByCrmSystem;
}